// import { getUserToken } from "@/js/auth";
import Vue from "vue";

export async function getImageDownloadLink(bundleId) {
  let response = await Vue.axios.get(
    `${process.env.VUE_APP_BACKEND_ADDRESS}image/${bundleId}/newGetDownloadUrl`
  );
  return response.data;
}

export async function getInvoiceDownloadLink(filename) {
  const payload = {
    filename: filename
  };

  let response = await Vue.axios.post(
    `${process.env.VUE_APP_BACKEND_ADDRESS}/getInvoiceLink`,
    payload
  );
  return response.data;
}
